export default {
    'diagram7-3a1': {
        'diagram-number': '7.',
        'elements': {
            'one': 'Market-creating innovations demand capital to grow, but they do create a lot of jobs',
            'two': 'Efficiency innovations – achieved by cutting the cost of a product or service – usually cut jobs ',
            'three': 'If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram7/i18n/en.js